<template>
  <span>
    <button class="btn btn-success"
            @click="showCreateProjectModal"
    >
      <font-awesome-icon icon="play" class="color-secondary mr-2"/>
      {{ $t('projects.create_button') }}
    </button>

    <!-- Decision modal template -->
    <b-modal ref="decision-project-modal" @hide="hideDecisionModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideDecisionModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-p-title">
            {{ $t('projects.create_button') }}
          </h5>

          <b-form-group style="width: 100%;">
            <div class="">
              <p>
                {{ $t('projects.create.create_project_decider_helper_text')}}
              </p>
              <!-- <p v-if="!showFullProjectRunMessage">
                {{ $t('projects.create.create_project_decider_helper_text') | truncate(250)}}
              </p>
              <div class="text-center mt-3" @click="showFullProjectRunMessage=!showFullProjectRunMessage">
                <span class="cursor-pointer" v-if="!showFullProjectRunMessage">
                  <span class="mr-2">
                    {{ $t('system.view_more') }}
                  </span>
                  <font-awesome-icon icon="chevron-down"/>
                </span>
                <span class="cursor-pointer" v-if="showFullProjectRunMessage">
                  <span class="mr-2">
                    {{ $t('system.view_less') }}
                  </span>
                  <font-awesome-icon icon="chevron-up"/>
                </span>
              </div> -->
            </div>
          </b-form-group>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>

      <b-form qid="create-p-form">
        <div class="form-container" style="height: 190px;">
          <div class="circle-content"
               @click="showRunExistingPModal"
               v-b-tooltip.hover
               :title="$t('projects.create.run_project_helper_text')"
          >
            <div class="circle cursor-pointer">
              <font-awesome-icon icon="calendar-alt"/>
            </div>
            <p>{{ $t('projects.projects_table.create_button') }}</p>
          </div>
          <div class="circle-content"
               @click="showCreatePModal"
               v-b-tooltip.hover
               :title="$t('projects.create.create_project_helper_text')"
          >
            <div class="circle cursor-pointer">
              <font-awesome-icon icon="plus-circle"/>
            </div>
            <p>{{ $t('projects.create.title') }}</p>
          </div>
        </div>

        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="text-right">
              <b-button class=""
                        variant="secondary"
                        @click="hideDecisionModal"
                        qid="create-p-cancel-button"
              >
                {{ $t('projects.create.cancel') }}
              </b-button>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Run existing project modal template -->
    <b-modal ref="run-existing-project" @hide="hideRunExistingPModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideRunExistingPModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="run-p-title">
            {{ $t('projects.projects_table.create_button') }}
          </h5>

          <b-form-group style="width: 100%;">
            <div class="">
              <p v-if="showFullProjectMessage">
                {{ $t('projects.create.run_project_helper_text') }}
              </p>
              <p v-if="!showFullProjectMessage">
                {{ $t('projects.create.run_project_helper_text') | truncate(150)}}
              </p>
              <div class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
                <span class="cursor-pointer" v-if="!showFullProjectMessage">
                  <span class="mr-2">
                    {{ $t('system.view_more') }}
                  </span>
                  <font-awesome-icon icon="chevron-down"/>
                </span>
                <span class="cursor-pointer" v-if="showFullProjectMessage">
                  <span class="mr-2">
                    {{ $t('system.view_less') }}
                  </span>
                  <font-awesome-icon icon="chevron-up"/>
                </span>
              </div>
            </div>
          </b-form-group>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="run-p-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="createFormSubmit" qid="run-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="run-p-ca-label">
              {{ $t('projects.create.compliance_activities_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="selectedCA"
                :options="caItems"
                :placeholder="$t('projects.create.compliance_activities_placeholder')"
                label="title"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadCA"
                @select="updateMessage"
                :preserveSearch="true"
                track-by="slug"
                qid="run-p-form-ca"
                required
            ></multiselect>

            <div class="row">
              <div class="col-sm-6">
                <p>
                  {{ $t('projects.create.include_scheduled') }}
                </p>
              </div>
              <div class="col-sm-6 text-right">
                <b-form-radio-group
                  v-model="includeScheduled"
                  :options="yesNoOptions"
                ></b-form-radio-group>
              </div>
            </div>
            <div class="mt-2" v-if="selectedCA && selectedCA.id && !selectedCA.scheduled">
              <font-awesome-icon
                  icon="exclamation-triangle"
                  class="risk-3 mr-1"
              />
              {{ $t('projects.schedule.not_scheduled_label') }}
            </div>
            <div class="mt-2" v-if="selectedCA && selectedCA.id && selectedCA.scheduled">
              <font-awesome-icon
                  icon="exclamation-triangle"
                  class="risk-9 mr-1"
              />
              {{ $t('projects.schedule.next_run_date_label') }}  {{ selectedCA.nextRun | formatDate }}
            </div>
          </b-form-group>

          <div v-if="selectedCA && selectedCA.id ">
            <b-form-group>
              <label qid="create-p-name-label">
                {{ $t('projects.schedule.start_date_label') }}<span class="mandatory"> *</span>
              </label>
              <datepicker
                  class="date-picker"
                  qid="form-due-date"
                  calendar-class="left"
                  v-model="form.start_date"
                  :clear-button="true"
                  :placeholder="$t('projects.schedule.start_date_placeholder')"
                  required
                  @selected="updateDisabled"
                  :disabledDates="disabledDates"
              ></datepicker>
            </b-form-group>

            <b-form-group>
              <label qid="create-p-name-label">
                {{ $t('projects.create.due_date_label') }}<span class="mandatory"> *</span>
              </label>
              <datepicker
                  class="date-picker"
                  qid="form-due-date"
                  calendar-class="left"
                  v-model="form.due_date"
                  :clear-button="true"
                  :placeholder="$t('projects.create.due_date_placeholder')"
                  required
                  :disabledDates="disabledEndDates"
              ></datepicker>
            </b-form-group>

            <b-form-group>
              <label qid="create-p-name-label">
                {{ $t('projects.create.message_label') }}
              </label>
              <b-form-textarea
                  qid="create-s-form-description"
                  v-model="form.schedule_message"
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('projects.create.message_placeholder')"
              ></b-form-textarea>
            </b-form-group>

            <b-form-checkbox
              v-model="includeAttachments"
              name="checkbox-disable"
              :value="1"
              :unchecked-value="0"
            >
              {{ $t('system.include_project_attachments') }}
            </b-form-checkbox>
          </div>

          <div v-if="!includeAttachments">
            <br>
            <h6>{{ $t('system.add_new_project_attachments') }}</h6>
            <b-form-group>
              <label qid="create-p-attachments-label">
                {{ $t('maintenance.retention_rules.create.attachments') }}
                &nbsp;
                <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
              </label>
              <br>
              <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
              <label class="btn btn-secondary cursor-pointer" qid="create-p-attachments-button">
                <input type="file"
                       name="fileupload"
                       value="fileupload"
                       multiple
                       id="file-rr"
                       @change="onFileChange"
                       @click="resetFile"
                >
                <span>
                  <font-awesome-icon icon="cloud-upload-alt" />
                  {{ $t('attachments.upload_button') }}
                </span>
              </label>
            </b-form-group>

            <b-form-group>
              <label qid="create-p-link-label">
                {{ $t('maintenance.third_parties.create.links_label') }}
              </label>
              <p v-for="(link, index) in form.links">
                <span class="float-right text-muted cursor-pointer"
                      @click="removeLinkItem(index)"
                      qid="create-p-link-remove"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
              </p>
              <div>
                <label class="mt-2">{{ $t('system.link') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLink"
                  :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                  qid="create-p-links"
                ></b-form-input>
                <label class="mt-2">{{ $t('table.name') }}</label>
                <b-form-input
                  type="text"
                  aria-describedby="inputGroup"
                  v-model="inputLinkName"
                  :placeholder="inputLink ? inputLink : $t('table.name')"
                  qid="create-p-links"
                ></b-form-input>
              </div>
              <span class="btn btn-link cursor-pointer float-right"
                    @click="handleLink"
                    qid="create-p-add-link"
              >
                + {{ $t('system.add_link') }}
              </span>
            </b-form-group>
          </div>
        </div>

        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideRunExistingPModal"
                            qid="create-p-cancel-button"
                  >
                    {{ $t('projects.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-p-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('system.run') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


    <!-- Create new project modal template -->
    <b-modal ref="create-project" @hide="hideCreatePModal" modal-class="task-modal" hide-footer>
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideCreatePModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="create-f-title">
            {{ $t('projects.create.title') }}
          </h5>

          <b-form-group style="width: 100%;">
            <div class="">
              <p v-if="showFullProjectMessage">
                {{ $t('projects.create.create_project_helper_text') }}
              </p>
              <p v-if="!showFullProjectMessage">
                {{ $t('projects.create.create_project_helper_text') | truncate(150)}}
              </p>
              <div class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
                <span class="cursor-pointer" v-if="!showFullProjectMessage">
                  <span class="mr-2">
                    {{ $t('system.view_more') }}
                  </span>
                  <font-awesome-icon icon="chevron-down"/>
                </span>
                <span class="cursor-pointer" v-if="showFullProjectMessage">
                  <span class="mr-2">
                    {{ $t('system.view_less') }}
                  </span>
                  <font-awesome-icon icon="chevron-up"/>
                </span>
              </div>
            </div>
          </b-form-group>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-f-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="formSubmit" qid="create-p-form">
        <div class="form-container">


          <b-form-group>
            <label qid="create-p-type-label">
              {{ $t('projects.create.type_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="projectType"
                :options="projectTypes"
                required
                :placeholder="$t('projects.create.type_placeholder')"
                label="name"
                v-if="type"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-type"
                @input="changeType"
                @selected="selectType"
                @remove="deselectType"
            ></multiselect>
            <multiselect
                v-model="projectType"
                :options="projectTypes"
                required
                group-values="items"
                group-label="group"
                :group-select="false"
                :placeholder="$t('projects.create.type_placeholder')"
                label="name"
                v-if="!type"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-type"
                @input="changeType"
                @selected="selectType"
                @remove="deselectType"
            ></multiselect>
            <span class="text-muted" v-if="projectType.value == 'control_assessment'">
              * {{ $t('maintenance.assessments.type.control_explainer_text') }}
            </span>
            <span class="text-muted" v-if="projectType.value == 'risk_assessment'">
              * {{ $t('maintenance.assessments.type.risk_explainer_text') }}
            </span>
            <span class="text-muted" v-if="projectType.value == 'bia_assessment'">
              * {{ $t('maintenance.assessments.type.bia_explainer_text') }}
            </span>
          </b-form-group>

          <b-form-group v-if="projectType && (projectType.value == 'control_assessment' || projectType.value == 'risk_assessment' || projectType.value == 'bia_assessment')">
            <label qid="create-p-a-label">
              {{ $t('projects.create.assessment_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="projectAssessment"
                :options="projectAssessments"
                :placeholder="$t('projects.create.assessment_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-a"
            ></multiselect>
            <p class="mt-2 text-muted" v-if="projectAssessment && projectAssessment.id && projectAssessment.description">
              {{ projectAssessment.description }}
            </p>
          </b-form-group>

          <b-form-group v-if="(projectType.value == 'update' || projectType.value == 'validation' || projectType.value == 'control')">
            <label qid="create-p-scope-label">
              {{ $t('projects.create.scope_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="projectScope"
                :options="projectScopes"
                :placeholder="$t('projects.create.scope_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-p-form-scope"
            ></multiselect>
          </b-form-group>

          <b-form-group>
            <label qid="create-s-name-label">
              {{ $t('projects.create.title_label') }}<span class="mandatory"> *</span>
            </label>
            <b-form-input
              qid="create-s-form-name"
              type="text"
              v-model="sForm.title"
              :maxLength="255"
              required
              :placeholder="$t('projects.create.title_placeholder')"
            ></b-form-input>
          </b-form-group>

          <b-form-group>
            <label qid="create-s-description-label">
              {{ $t('projects.create.description_label') }}
            </label>
            <b-form-textarea
              qid="create-s-form-description"
              v-model="sForm.description"
              rows="4"
              max-rows="4"
              :placeholder="$t('projects.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>

          <b-form-radio-group
            v-model="control_type"
            :options="controlTypeOptions"
            required
            :allow-empty="false"
          ></b-form-radio-group>
          <div v-if="control_type == 'one time'" class="text-muted">* {{ $t('projects.one_time_project_description') }}</div>
          <div v-else class="text-muted">* {{ $t('projects.continuous_project_description') }}</div>
          <br>

          <b-form-group>
            <label qid="create-s-users-label">
              {{ $t('projects.create.owners_label') }}<span class="mandatory"> *</span>
            </label>
            <multiselect
                v-model="selectedUsers"
                :options="users"
                :multiple="true"
                :taggable="false"
                track-by="slug"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('projects.create.owners_placeholder')"
                label="name"
                @search-change="loadUsers"
                qid="create-s-users-select"
            >
              <template slot="tag" slot-scope="props">
                <span class="mr-3 user-tag">
                  <Avatar :object="props.option" size="xs"></Avatar>
                  <span class="ml-2">{{ props.option.name }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group>
            <label qid="create-do-tags-label">
              {{ $t('processes.create.tags_label') }}
            </label>
            <multiselect
                v-model="selectedTags"
                :options="tags"
                :multiple="true"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :taggable="true"
                track-by="name_translated"
                :placeholder="$t('processes.create.tags_placeholder')"
                label="name_translated"
                qid="create-do-tags-select"
                @search-change="loadTags"
                @tag="addTag"
            ></multiselect>
          </b-form-group>
        </div>

        <div class="proxy-footer">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideCreatePModal"
                            qid="create-p-cancel-button"
                  >
                    {{ $t('projects.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            :disabled="buttonDisabled"
                            qid="create-p-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('projects.create_label') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </b-modal>


  </span>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'CreateProjectModal',
    data: function() {
      return {
        form: {
          start_date: '',
          due_date: '',
          schedule_message: '',
          links: []
        },
        sForm: {
          title: '',
          description: '',
          client:''
        },
        disabledDates: {
          to: new Date(Date.now() - 8640000)
        },
        disabledEndDates: {
          to: new Date(Date.now() - 8640000)
        },
        yesNoOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0},
        ],
        control_type: 'continuous',
        controlTypeOptions: [
          {text: this.$t('projects.continuous_project_title'), value: 'continuous'},
          {text: this.$t('projects.one_time_project_title'), value: 'one time'},
        ],
        caItems: [],
        selectedCA: [],
        buttonDisabled: false,
        error: '',
        includeScheduled: 0,
        projectLoading: false,
        showFullProjectRunMessage: false,
        showFullProjectMessage: false,
        showUsersModal: false,
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        showAttachments: false,
        includeAttachments: 1,


        tags: [],
        selectedTags: [],
        users: [],
        selectedUsers: [],
        newTags: [],
        projectAssetTypes: [
          { name: this.$t('projects.type.update'), value: 'update' }
        ],
        projectControlTypes: [
          { name: this.$t('projects.type.control'), value: 'control' },
          { name: this.$t('projects.type.security_measure'), value: 'security_measure' }
        ],
        projectAssessmentTypes: [
          { name: this.$t('maintenance.assessments.type.risk'), value: 'risk_assessment' },
          { name: this.$t('maintenance.assessments.type.control'), value: 'control_assessment' },
          { name: this.$t('maintenance.assessments.type.bia'), value: 'bia_assessment' },
        ],

        loadAssessmentType: '',
        projectScopes: [

        ],
        projectType: [],
        projectTypes: [
          // {
          //   group: this.$t('projects.asset_project_list_title'),
          //   items: [
          //     { name: this.$t('projects.type.update'), value: 'update' },
          //     { name: this.$t('projects.type.validation'), value: 'validation' }
          //   ]
          // },
          // {
          //   group: this.$t('projects.control_project_list_title'),
          //   items: [
          //     { name: this.$t('projects.type.control'), value: 'control' },
          //     { name: this.$t('projects.type.security_measure'), value: 'security_measure' }
          //   ]
          // },
          // {
          //   group: this.$t('projects.assessment_project_list_title'),
          //   items: [
          //     { name: this.$t('maintenance.assessments.type.control'), value: 'control_assessment' },
          //     { name: this.$t('maintenance.assessments.type.risk'), value: 'risk_assessment' },
          //     { name: this.$t('maintenance.assessments.type.bia'), value: 'bia_assessment' },
          //   ]
          // },
        ],

        projectScope: [],
        projectAssessment: [],
        projectAssessments: [],
        create_type: ''
      }
    },
    props: {
      type: {},
      types: {},
      scope: {}
    },
    components: {
      Avatar,
      Datepicker
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      getClient: function () {

      },
      includeScheduled: function () {
        this.loadCA()
      },
      projectAssessment: function (object) {
        this.setProjectName(object)
      }
    },
    methods: {
      showCreateProjectModal() {
        this.$refs['decision-project-modal'].show()
      },
      hideDecisionModal() {
        this.$refs['decision-project-modal'].hide()
      },
      showRunExistingPModal() {
        let self = this;

        var moment = require('moment');
        this.loadCA()
        this.form.start_date = moment().toDate()
        this.form.due_date = moment().add(14, 'day').toDate()
        this.updateDisabled()
        this.error = '';

        this.$refs['run-existing-project'].show()
        this.hideDecisionModal()
      },
      hideRunExistingPModal() {
        this.selectedCA = []
        this.form.start_date = ''
        this.form.due_date = ''
        this.form.links = [];
        this.inputLink = '';
        this.selectedFiles = [];
        this.form.schedule_message = ''

        this.$refs['run-existing-project'].hide()
      },
      setProjectName(object) {
        this.sForm.title = object.name;
      },
      showCreatePModal () {
        if (this.getClient && this.getClient.slug) {
          this.loadTags()
          this.loadUsers()
          this.setTypes()

          this.$refs['create-project'].show()

          this.hideDecisionModal()
        }
      },
      hideCreatePModal () {
        this.sForm.title = ''
        this.sForm.description = ''
        this.sForm.tags = []
        this.sForm.users = []
        this.sForm.type = ''
        this.sForm.scope = ''
        this.sForm.assessment = ''
        this.sForm.control_type = ''

        this.$refs['create-project'].hide()
      },
      updateDisabled(date) {
        this.disabledEndDates.to = date ? date : new Date(this.form.start_date - 8640000)
      },
      updateMessage(object) {
        if (object.schedule_message) {
          this.form.schedule_message = object.schedule_message
        }
      },
      resetFile() {
        let imagefile = document.querySelector('#file-rr');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file-rr');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.form.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.form.links.splice(index, 1);
      },
      createFormSubmit(evt) {
        var moment = require('moment');
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        let sizeError = false;
        let files = document.querySelector('#file-rr');

        // Call handle link function to gather link from link input
        this.handleLink()

        let formData = new FormData();

        // Append list of attachments to FormData
        for (var i = 0; i < files.files.length; i++) {
          // Equal to 10 MB
          if (files.files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append("files[]", files.files[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.form.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.form.links[i]));
        }

        if (this.selectedCA && this.selectedCA.slug) {
          formData.append("compliance_activity", this.selectedCA.slug);
        }

        this.form.due_date = this.form.due_date ? moment(this.form.due_date).format('YYYY-MM-DD') : '';
        formData.append("due_date", this.form.due_date);

        formData.append("include_attachments", this.includeAttachments);

        this.form.start_date = this.form.start_date ? moment(this.form.start_date).format('YYYY-MM-DD') : '';
        formData.append("start_date", this.form.start_date);

        formData.append("schedule_message", this.form.schedule_message);

        if (sizeError) {
          this.error = this.$t('system.file_size')
          this.buttonDisabled = false;
        } else {
          this.buttonDisabled = true;

          if (this.selectedCA && this.selectedCA.slug && this.form.start_date <= this.form.due_date) {
            piincHttp.post('projects/' + this.selectedCA.slug + '/projects', formData, {

            }).then(function(response) {
              self.hideDecisionModal();
              self.$emit('reloadContent', response.data);
              self.$toastr('success', self.$t('projects.create.project_success'))
              self.buttonDisabled = false;
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
                if (error.data.errors.start_date) {
                  self.error += ' ' + error.data.errors.start_date[0]
                }
                if (error.data.errors.due_date) {
                  self.error += ' ' + error.data.errors.due_date[0]
                }
              }
            })
          } else {
            self.buttonDisabled = false;
            self.error = ''
            if (!this.selectedCA || (this.selectedCA && !this.selectedCA.slug)) {
              self.error = self.$t('activities.system.copy.error');
            }
            if (this.form.start_date > this.form.due_date) {
              self.error = self.error + ' ' + self.$t('projects.schedule.start_date_greater_error');
            }
          }
        }

      },
      loadCA(query) {
        let self = this;
        this.projectLoading = true
        piincHttp.get('projects', { params:
          {
            per_page: 100,
            control_type: this.control_type,
            scheduled: this.includeScheduled ? undefined : this.includeScheduled,
            client: this.getClient.slug,
            types: this.types
          }
        }).then(function(response) {
          self.projectLoading = false
          self.caItems = response.data.items
          if (self.caItems && !self.caItems.length && !query) {
            self.caItems.push({title: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      addTag(newTag) {
        const tag = {
          name: newTag,
          translatable: newTag,
          name_translated: newTag
        }
        this.selectedTags.push(tag)
        this.newTags.push(tag)
      },
      goToList() {
        if (this.$route.params.create_type) {
          if (this.$route.params.create_type === 'assessment') {
            this.$router.push('/projects/assessment-projects')
          } else if (this.$route.params.create_type === 'control') {
            this.$router.push('/projects/control-projects')
          } else if (this.$route.params.create_type === 'update') {
            this.$router.push('/projects/asset-projects')
          }
        } else {
          this.$router.push('/projects/gantt')
        }
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();
        let files = document.querySelector('#file');

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        // Append list of users to FormData
        if (this.selectedUsers && this.selectedUsers.length) {
          for (var i = 0; i < this.selectedUsers.length; i++) {
            formData.append("users[]", this.selectedUsers[i].id);
          }
        }

        // Additional check - if scope is selected, append it to form data
        if (this.projectScope && this.projectScope.value) {
          formData.append("scope", this.projectScope.value);
        }

        // Additional check - if type is selected, append it to form data
        if (this.projectType && this.projectType.value) {
          formData.append("type", this.projectType.value);
        }

        if (this.projectAssessment && this.projectAssessment.id) {
          formData.append("assessment", this.projectAssessment.id);
        }

        if (this.control_type && this.control_type != '') {
          formData.append("control_type", this.control_type);
        }

        if (this.selectedTags && this.selectedTags.length) {
          for (var i = 0; i < this.selectedTags.length; i++) {
            formData.append("tags[]", this.selectedTags[i].name_translated);
          }
        }

        formData.append("title", this.sForm.title);
        formData.append("description", this.sForm.description);
        formData.append("client", this.getClient.slug);

        if (
            ((this.projectScope && this.projectScope.value && this.projectType != null && this.projectType.value) ||
            (this.projectType != null && this.projectType.value && this.projectType.value == 'security_measure') ||
            (this.projectType != null && this.projectType.value && (this.projectType.value == 'control_assessment' || this.projectType.value == 'risk_assessment' || this.projectType.value == 'bia_assessment') && this.projectAssessment && this.projectAssessment.id)) &&
            this.selectedUsers && this.selectedUsers.length
          ) {
          piincHttp.post('/projects', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('projects.create.success'))
            self.buttonDisabled = false;
            self.$router.push({ name: 'projects.view', params: { slug: response.data.slug }})
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              // Print whole array of actual errors beside message
              self.error = self.error + '\n\n' + JSON.stringify(error.data.errors);
            }
          })
        } else {
          this.error = '';
          if (!this.projectType || (this.projectType && !this.projectType.value)) {
            this.error += this.$t('system.type_error_message')
          }
          if (!this.selectedUsers.length) {
            this.error += this.$t('system.users_error_message')
          }
          if ((!this.projectScope || (this.projectScope && !this.projectScope.value)) && ((this.projectType && this.projectType.value && this.projectType.value != 'control_assessment' && this.projectType.value != 'security_measure') || (!this.projectType || (this.projectType && !this.projectType.value)))) {
            this.error += this.$t('system.scope_error_message')
          }
          if ((!this.projectAssessment || (this.projectAssessment && !this.projectAssessment.id)) && this.projectType && this.projectType.value && (this.projectType.value == 'control_assessment' || this.projectType.value == 'risk_assessment' || this.projectType.value == 'bia_assessment')) {
            this.error += this.$t('system.assessment_error_message')
          }
          this.buttonDisabled = false;
        }
      },
      loadAssessments(query) {
        let self = this;

        if (this.projectType.value == 'control_assessment') {
          this.loadAssessmentType = 'control'
        }else{
          if (this.projectType.value == 'risk_assessment') {
            this.loadAssessmentType = 'risk'
          }else{
            if (this.projectType.value == 'bia_assessment') {
              this.loadAssessmentType = 'bia'
            }
          }
        }

        piincHttp.get('assessments', { params:
          {
            per_page: 100,
            type: this.loadAssessmentType,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.projectAssessments = response.data.items
          if (self.projectAssessments && !self.projectAssessments.length && !query) {
            self.projectAssessments.push({title: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadUsers(query) {
        let self = this;
        piincHttp.get('users', { params:
          {
            client: this.getClient.id,
            keyword: query ? query : undefined,
            per_page: 50
          }
        }).then(function(response) {
          self.users = response.data.items
          if (self.users && !self.users.length && !query) {
            self.users.push({name: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      loadTags(query) {
        let self = this;
        piincHttp.get('tags', { params:
                  {
                    client: this.getClient.slug,
                    keyword: query ? query : undefined
                  }
        }).then(function(response) {
          self.tags = response.data
          for (var i = 0; i < self.newTags.length; i++) {
            self.tags.push(self.newTags[i]);
          }
          if (self.tags && !self.tags.length && !query) {
            self.tags.push({name_translated: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      },
      changeType(){
        if (this.projectType.value == 'control_assessment' || this.projectType.value == 'risk_assessment' || this.projectType.value == 'bia_assessment') {
          this.loadAssessments()
        }

        // if (this.$route.params.create_scope) {
        //   if (this.$route.params.create_scope == 'processingActivities') {
        //     this.projectScopes.push({ name: this.$t('projects.scope.process'), value: 'process' })
        //     this.projectScopes.push({ name: this.$t('projects.scope.activity'), value: 'activity' })
        //   }
        // } else {
        this.projectScopes = []
        this.projectScope = []

        if (this.getClient.processingActivitiesModule) {
          this.projectScopes.push({ name: this.$t('projects.scope.process'), value: 'process' })
          this.projectScopes.push({ name: this.$t('projects.scope.activity'), value: 'activity' })
        }
        if (this.getClient.systemModule && this.projectType.value != 'bia_assessment') {
          this.projectScopes.push({ name: this.$t('projects.scope.system'), value: 'system' })
        }
        if (this.getClient.contractBasicModule && this.projectType.value != 'bia_assessment') {
          this.projectScopes.push({ name: this.$t('projects.scope.third_party'), value: 'third_party' })
        }
        if (this.getClient.policyModule && this.projectType.value != 'bia_assessment') {
          this.projectScopes.push({ name: this.$t('projects.scope.policy'), value: 'policy' })
        }
        // }
      },
      selectType(type) {
        if (type.value == 'validation') {
          if (!this.getClient.gdprAdvancedModule) {
            let processIndex = _.findIndex(this.projectScopes, function(o) { return o.value == 'process'; });
            this.projectScopes.splice(processIndex, 1);
            let activityIndex = _.findIndex(this.projectScopes, function(o) { return o.value == 'activity'; });
            this.projectScopes.splice(processIndex, 1);
          }
        } else {
          if (this.getClient.processingActivitiesModule) {
            if (_.findIndex(this.projectScopes, function(o) { return o.value == 'process'; }) == -1) {
              this.projectScopes.push({ name: this.$t('projects.scope.process'), value: 'process' })
            }
            if (_.findIndex(this.projectScopes, function(o) { return o.value == 'activity'; }) == -1) {
              this.projectScopes.push({ name: this.$t('projects.scope.activity'), value: 'activity' })
            }
          }
        }
      },
      deselectType(type) {
        if (this.getClient.processingActivitiesModule) {
          if (_.findIndex(this.projectScopes, function(o) { return o.value == 'process'; }) == -1) {
            this.projectScopes.push({ name: this.$t('projects.scope.process'), value: 'process' })
          }
          if (_.findIndex(this.projectScopes, function(o) { return o.value == 'activity'; }) == -1) {
            this.projectScopes.push({ name: this.$t('projects.scope.activity'), value: 'activity' })
          }
        }
      },
      setTypes() {
        this.projectTypes = []

        // this.control_type = this.$route.params.control_type

        if (this.type) {
          if (this.type === 'assessment') {
            this.projectTypes = this.projectAssessmentTypes
          } else if (this.type === 'control') {
            this.projectTypes = this.projectControlTypes
          } else if (this.type === 'update') {
            this.projectTypes = this.projectAssetTypes
            if (this.getClient.gdprAdvancedModule) {
              this.projectTypes.push({ name: this.$t('projects.type.validation'), value: 'validation' })
            }
          }
        }
        else {
          if (this.getClient.processingActivitiesModule) {
            if (this.getClient.gdprAdvancedModule) {
              this.projectTypes.push(
                {
                  group: this.$t('projects.asset_project_list_title'),
                  items: [
                    { name: this.$t('projects.type.update'), value: 'update' },
                    { name: this.$t('projects.type.validation'), value: 'validation' }
                  ]
                }
              )
            }else{
              this.projectTypes.push(
                {
                  group: this.$t('projects.asset_project_list_title'),
                  items: [
                    { name: this.$t('projects.type.update'), value: 'update' }
                  ]
                }
              )
            }
          }
          // this.projectTypes.push(...this.projectAssetTypes)

          if (this.getClient.riskModule) {
            this.projectTypes.push(
              {
                group: this.$t('projects.control_project_list_title'),
                items: [
                  { name: this.$t('projects.type.control'), value: 'control' },
                  { name: this.$t('projects.type.security_measure'), value: 'security_measure' }
                ]
              }
            )
            // this.projectTypes.push({ name: this.$t('projects.type.control'), value: 'control' })
            // this.projectTypes.push({ name: this.$t('projects.type.security_measure'), value: 'security_measure' })
          }
          if (this.getClient.assessmentModule) {
            this.projectTypes.push(
              {
                group: this.$t('projects.assessment_project_list_title'),
                items: [
                  { name: this.$t('maintenance.assessments.type.control'), value: 'control_assessment' },
                  { name: this.$t('maintenance.assessments.type.risk'), value: 'risk_assessment' },
                  { name: this.$t('maintenance.assessments.type.bia'), value: 'bia_assessment' },
                ]
              },
            )
            // this.projectTypes.push({ name: this.$t('maintenance.assessments.type.control'), value: 'control_assessment' })
            // this.projectTypes.push({ name: this.$t('maintenance.assessments.type.risk'), value: 'risk_assessment' })
            // this.projectTypes.push({ name: this.$t('maintenance.assessments.type.bia'), value: 'bia_assessment' })
          }
          // if (this.getClient.gdprAdvancedModule) {
          //   this.projectTypes.push({ name: this.$t('projects.type.validation'), value: 'validation' })
          // }

        }
      }
    },
    created () {

    }
  }
</script>
